import { initTrimLevel } from './modules/initTrimLevel.js';

export const setupTrimLevels = function() {
    const cmsContentSlice = document.querySelectorAll('.cms-content-trim-level__slider');
    const cmsContentSliceLength = cmsContentSlice.length;
    if (cmsContentSliceLength <= 0) {
        return;
    }
    for (let index = 0; index < cmsContentSliceLength; index++) {
        initTrimLevel(cmsContentSlice[index]);
    }
};